import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { MenuProps } from 'antd';
import { UseNavbar, MenuItem } from '../Navbar.types';
import { ITEMS } from '../Navbar.constants';
import { NAMESPACE, PRIVATE_PATH } from '@/constants';

export const useNavbar: UseNavbar = () => {
  const { t } = useTranslation(NAMESPACE.MEDIA_PLAN_PAGE);
  const { pathname } = useLocation();
  const [current, setCurrent] = useState<string>(PRIVATE_PATH.MEDIA_PLAN);

  const menuItems: MenuItem[] = useMemo(
    () => ITEMS.map(({ i18nKey, ...itemData }) => ({ ...itemData, title: t(i18nKey) })),
    [t]
  );

  useEffect(() => {
    const subRoute = pathname.split('/')[2];

    setCurrent(subRoute ? `/${subRoute}` : '');
  }, [pathname]);

  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key);
  };

  return { menuItems, current, onClick };
};
